﻿'use strict';
import Axios from "axios";

import { TweenLite, CSSPlugin, ScrollToPlugin } from "gsap/all";

const plugins = [CSSPlugin, ScrollToPlugin];

export default class ClassListing {

    constructor() {

        if (!d.querySelector("#localMarketPartners") || d.querySelector("#localMarketPartners.partners")) {
            return;
        }
        return;
        const allClasses = d.querySelectorAll(".class-card");

        let cityOptions = [];
        let dateOptions = [];
        let organOptions = [];

        const hideEmptyHeaders = () => {
            var _dates = d.querySelector("#dateOption li.sel").dataset.value;

            if (_dates) {
                d.querySelectorAll(".weekHeader").forEach((header) => {
                    header.style.display = "none";
                });

                d.querySelectorAll(".card-grid").forEach((row, i) => {
                    var isVisible = false;

                    row.querySelectorAll(".class-card").forEach((card, x) => {

                        if (card.style.display != "none") {
                            isVisible = true;
                        }
                    });

                    if (isVisible) {
     
                        row.previousElementSibling.style.display = "";
                    }
                });
            } else {

                d.querySelectorAll(".weekGroup").forEach((group) => {
                    group.classList.remove("visible");
                });

                d.querySelectorAll(".card-grid").forEach((row, i) => {
                    var isVisible = false;

                    row.querySelectorAll(".class-card").forEach((card, x) => {

                        if (card.style.display != "none") {
                            isVisible = true;
                        }
                    });

                    if (isVisible) {
                        row.parentElement.classList.add("visible");
                    }
                });


                d.querySelectorAll(".card-grid").forEach((row, i) => {
                    var isVisible = false;

                    row.querySelectorAll(".class-card").forEach((card, x) => {

                        if (card.style.display != "none") {
                            isVisible = true;
                        }
                    });

                    if (!isVisible) {

                        if (!row.parentElement.classList.contains("visible") && row.parentElement.querySelector(".large.weekHeader")) {
                            row.parentElement.querySelector(".large.weekHeader").style.display = "none";
                        }

                        row.previousElementSibling.style.display = "none";
                    } else {

                        if (row.parentElement.querySelector(".large.weekHeader")) {
                            row.parentElement.querySelector(".large.weekHeader").style.display = "";
                        }

                        row.previousElementSibling.style.display = "";
                    }
                });
            }
        }




        const applyFilter = (suppressAnimation) => {


            let filterListing = [];
            let activeFilterItems = d.querySelectorAll(`.class-card`);

            allClasses.forEach((card) => {
                card.style.visibility = "";
                card.style.opacity = "";
                card.style.display = "";
            });



            const city = d.querySelector("#cityOption li.sel").dataset.value;
            const _dates = d.querySelector("#dateOption li.sel").dataset.value;
            const organization = d.querySelector("#organizationOption li.sel").dataset.value;

            let cityNotQuery = "";
            let dateNotQuery = "";
            let organizationNotQuery = "";

            let cityQuery = "";
            let dateQuery = "";
            let organizationQuery = "";

            let cityName = "";
            let dateName = "";
            let organizationName = "";

            if (city) {


                cityNotQuery = `:not([data-city='${city}'])`;
                cityQuery = `[data-city='${city}']`;
                cityName = city;
            }

            if (_dates) {
                dateNotQuery = `:not([data-date='${_dates}'])`;
                dateQuery = `[data-date='${_dates}']`;
                dateName = _dates;
            }

            if (organization) {

                organizationName = organization;
                organizationNotQuery = `:not([data-organization='${organization}'])`;
                organizationQuery = `[data-organization='${organization}']`;
            }

            if (window.hasOwnProperty("gtag")) {
                gtag('event', 'pyc_schedule_filter', {
                    'city': cityName,
                    'date': dateName,
                    'organization': organizationName
                });
            }

            activeFilterItems = d.querySelectorAll(`.class-card${cityQuery}${dateQuery}${organizationQuery}`);

            cityOptions = d.querySelectorAll(`.class-card${dateQuery}${organizationQuery}`);
            dateOptions = d.querySelectorAll(`.class-card${cityQuery}${organizationQuery}`);
            organOptions = d.querySelectorAll(`.class-card${cityQuery}${dateQuery}`);

            allClasses.forEach((card) => {
                let found = false;

                activeFilterItems.forEach((activeCard) => {
                    if (card == activeCard) {
                        found = true;
                    }
                });
                if (!found) {
                    filterListing.push(card);
                }

            });

            if (activeFilterItems) {
                const fuse = suppressAnimation ? 0 : .5;
                const shortFuse = suppressAnimation ? 0 : .25;
                TweenLite.to(allClasses, shortFuse, {
                    autoAlpha: 0, onComplete: () => {

                        filterListing.forEach((item, i) => {

                            item.style.display = "none";
                            hideEmptyHeaders();
                        });


                        allClasses.forEach((item, i) => {

                            TweenLite.to(item, fuse, {
                                autoAlpha: 1,
                                delay: i * .05,
                                onComplete: () => {
                                    hideEmptyHeaders();
                                }
                            });

                        });
                    }
                });



            }


            /*APPLY DROPDOWN STATISTICS*/
            d.querySelectorAll(".select__image__options li").forEach((item) => {
                item.classList.remove("disabled");
            });

            let activeCities = [""];
            let activeDates = [""];
            let activeOrganizations = [""];


            cityOptions.forEach((card) => {


                const _city = card.dataset.city;

                if (activeCities.indexOf(_city) < 0) {
                    activeCities.push(_city);
                }
            });

            organOptions.forEach((card) => {
                const _organization = card.dataset.organization;


                if (activeOrganizations.indexOf(_organization) < 0) {
                    activeOrganizations.push(_organization);
                }

            });

            dateOptions.forEach((card) => {

                const _date = card.dataset.date;

                if (activeDates.indexOf(_date) < 0) {
                    activeDates.push(_date);
                }
            });



            //console.log("active items:: ", activeFilterItems, " :: active stats:: ", activeCities, " :: ", activeDates, " :: ", activeOrganizations);

            d.querySelectorAll("#cityOption li").forEach((item) => {
                if (activeCities.indexOf(item.dataset.value) < 0 && item.dataset.value != "") {
                    item.classList.add("disabled");
                }
            });


            d.querySelectorAll("#dateOption li").forEach((item) => {
                if (activeDates.indexOf(item.dataset.value) < 0 && item.dataset.value != "") {
                    item.classList.add("disabled");
                }
            });

            d.querySelectorAll("#organizationOption li").forEach((item) => {
                if (activeOrganizations.indexOf(item.dataset.value) < 0 && item.dataset.value != "") {
                    item.classList.add("disabled");
                }
            });
        };


        if (d.querySelector("#cityOption")) {


            d.querySelector("#cityOption").addEventListener("change", (e) => {
                const value = e.detail.dataset.value;
                applyFilter();

                var city = d.querySelector("#cityOption li.sel").dataset.value ? `/${d.querySelector("#cityOption li.sel").dataset.value}` : '';
                var partner = d.querySelector("#organizationOption li.sel").dataset.value ? `partner=${d.querySelector("#organizationOption li.sel").dataset.value}` : "";
                var date = d.querySelector("#dateOption li.sel").dataset.value ? `date=${d.querySelector("#dateOption li.sel").dataset.value}` : "";
                var question = partner || date ? "?" : "";
                var _and = question && partner ? "&" : "";
                var state = { city: d.querySelector("#cityOption li.sel").dataset.value, partner: d.querySelector("#organizationOption li.sel").dataset.value, date: d.querySelector("#dateOption li.sel").dataset.value };
                history.pushState(state, "", `/community/schedule${city}${question}${partner}${_and}${date}`);
            });
        }
        if (d.querySelector("#dateOption")) {
            d.querySelector("#dateOption").addEventListener("change", (e) => {
                const value = e.detail.dataset.value;
                applyFilter();

                var city = d.querySelector("#cityOption li.sel").dataset.value ? `/${d.querySelector("#cityOption li.sel").dataset.value}` : '';
                var partner = d.querySelector("#organizationOption li.sel").dataset.value ? `partner=${d.querySelector("#organizationOption li.sel").dataset.value}` : "";
                var date = d.querySelector("#dateOption li.sel").dataset.value ? `date=${d.querySelector("#dateOption li.sel").dataset.value}` : "";
                var question = partner || date ? "?" : "";
                var _and = question && partner ? "&" : "";
                var state = { city: d.querySelector("#cityOption li.sel").dataset.value, partner: d.querySelector("#organizationOption li.sel").dataset.value, date: d.querySelector("#dateOption li.sel").dataset.value };
                history.pushState(state, "", `/community/schedule${city}${question}${partner}${_and}${date}`);
            });
        }

        if (d.querySelector("#organizationOption")) {
            d.querySelector("#organizationOption").addEventListener("change", (e) => {
                const value = e.detail.dataset.value;
                applyFilter();

                var city = d.querySelector("#cityOption li.sel").dataset.value ? `/${d.querySelector("#cityOption li.sel").dataset.value}` : '';
                var partner = d.querySelector("#organizationOption li.sel").dataset.value ? `partner=${d.querySelector("#organizationOption li.sel").dataset.value}` : "";
                var date = d.querySelector("#dateOption li.sel").dataset.value ? `date=${d.querySelector("#dateOption li.sel").dataset.value}` : "";
                var question = partner || date ? "?" : "";
                var _and = question && partner ? "&" : "";
                var state = { city: d.querySelector("#cityOption li.sel").dataset.value, partner: d.querySelector("#organizationOption li.sel").dataset.value, date: d.querySelector("#dateOption li.sel").dataset.value };
                history.pushState(state, "", `/community/schedule${city}${question}${partner}${_and}${date}`);

            });
        }
        applyFilter(true);

        const loadCorrectModal = (currentTarget, btn) => {
           // var btn = evt.currentTarget.querySelector("a.more_info");

            Axios.get(`/api/pyc/IsClassFull?classid=${btn.dataset.classid}`).then((result) => {

                if (result.data != null) {

                    if (result.data == true) {
                        window.waitlistModalClass.OpenWaitlistModal(btn.dataset.organizationid, btn.dataset.classid, currentTarget);
                    } else {
                        window.registrationModal.OpenRegModal(btn.dataset.organizationid, btn.dataset.classid, currentTarget);
                    }

                }

            });
        }

        allClasses.forEach((card, i) => {

            card.addEventListener("click", (e) => {

                var btn = e.currentTarget.querySelector("a.more_info");
                if (btn) {
                    loadCorrectModal(e.currentTarget, btn);
                   
                }
            });
        });


        window.addEventListener("popstate", (event) => {
            if (event.state) {
                d.querySelector(`#cityOption li[data-value='${event.state.city}']`).dispatchEvent(new Event('click'));
                d.querySelector(`#organizationOption li[data-value='${event.state.partner}']`).dispatchEvent(new Event('click'));
                d.querySelector(`#dateOption li[data-value='${event.state.date}']`).dispatchEvent(new Event('click'));
            } else {
                d.querySelector(`#cityOption li[data-value='']`).dispatchEvent(new Event('click'));
                d.querySelector(`#organizationOption li[data-value='']`).dispatchEvent(new Event('click'));
                d.querySelector(`#dateOption li[data-value='']`).dispatchEvent(new Event('click'));
            }
        });


    }
}